<template>
  <v-btn small depressed color="error" @click="handleButtonClick">
    {{ $t('asset_wise.disconnect') }}
  </v-btn>
</template>

<script>
import { mapGetters } from 'vuex'
import { disconnectBroker } from '@/api/assetwise'

export default {
  props: {
    value: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    async handleButtonClick() {
      try {
        const { value } = await this.$swal({
          type: 'question',
          title: this.$t('asset_wise.disconnect_question', [this.value]),
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true,
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            this.$swal.getCancelButton().style.display = 'none'
            await disconnectBroker({
              page_id: this.selectedBot.pageid,
              broker_no: this.value
            })
            return true
          },
          allowOutsideClick: () => !this.$swal.isLoading(),
          allowEscapeKey: () => !this.$swal.isLoading()
        })

        if (!value) return

        this.$emit('success', this.value)
      } catch (error) {
        this.$swal(this.$t('Something went wrong'), undefined, 'error')
        console.error(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/AssetWise/Management/Broker/DisconnectButton.vue